import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { CAPABILITIES } from "@/constants/capabilities";

/**
 * Collapsible "What can TACO do?" pill button and capability accordion.
 * Placed between the hero subtitle and the form card on the homepage.
 */
const CapabilitiesAccordion: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex flex-col items-center mt-4">
      {/* Toggle button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="inline-flex items-center gap-1.5 px-3.5 py-1.5 border border-border rounded-full bg-background text-blue-600 dark:text-blue-400 text-sm font-medium hover:bg-muted hover:border-blue-500 dark:hover:border-blue-400 transition-all duration-150 cursor-pointer"
      >
        <span>What can TACO do?</span>
        <ChevronDown
          className={`h-4 w-4 transition-transform duration-250 ${isOpen ? "rotate-180" : ""}`}
        />
      </button>

      {/* Accordion content */}
      <div
        className={`w-full max-w-4xl px-4 overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? "max-h-[2000px] opacity-100 mt-4" : "max-h-0 opacity-0 mt-0"
        }`}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2.5 p-4 bg-background border border-border rounded-lg shadow-sm text-left">
          {CAPABILITIES.map((cap, index) => (
            <div
              key={index}
              className="flex items-start gap-2 p-2 rounded-md hover:bg-muted transition-colors duration-150"
            >
              <span className="text-blue-600 dark:text-blue-400 mt-0.5 flex-shrink-0">
                <cap.icon className="h-4 w-4" />
              </span>
              <div className="flex flex-col">
                <span className="text-xs font-semibold text-foreground">
                  {cap.title}
                </span>
                <span className="text-xs text-muted-foreground leading-relaxed">
                  {cap.description}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CapabilitiesAccordion;
